import React from 'react';
import classNames from 'classnames';
import { safeHTML } from '../../../utils/safeHTML';
import { useTranslation } from '../../../translations';

const PrizesItem = React.forwardRef(function PrizesItem(props, ref) {
  const { className, children, value, image, title, description, onClick } = props;
  const { t } = useTranslation();

  return (
    <div className={classNames('prizes__item', className)} ref={ref} onClick={onClick}>
      <div className={'prizes__item-box'}>
        <div className='prizes__item-image'>{image && <img src={image} alt={t(title)} />}</div>
        {title && <div className='prizes__item-title'>{safeHTML(t(title))}</div>}
        {description && <div className='prizes__item-description'>{safeHTML(t(description))}</div>}
        {value && <div className='prizes__item-value'>{`+${value}`}</div>}
        {children}
      </div>
    </div>
  );
});
export default PrizesItem;
PrizesItem.propTypes = {};
